import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import axios from 'axios';

@Component({
  selector: 'app-printbarcode',
  templateUrl: './printbarcode.component.html',
  styleUrls: ['./printbarcode.component.css']
})
export class PrintbarcodeComponent implements OnInit, OnDestroy {


  constructor(private route: ActivatedRoute) { }
  barcodevalue: string = '1234567890';
  truckcode: any[];
  ngOnInit(): void {
    let id = this.route.snapshot.paramMap.get('truck_q1');
    let id2 = this.route.snapshot.paramMap.get('truck_q2');
    this.truckcode = [id, id2];
    this.Loadbarcodedata();
  }

  mylist = [];
  dateLOC: string;
  Loadbarcodedata() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_qcardYard?truck_q1=" + this.truckcode[0] + "&truck_q2=" + this.truckcode[1];
    axios.get(url).then(res => { this.mylist = res.data.recordset; }).catch(err => { throw err })
    let options: any = {
      year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit"
    };
    this.dateLOC = (new Date()).toLocaleString('th-TH', options);
  }

  print_p() {
    setTimeout(() => {
      window.print();
    }, 100);
  }

  ngOnDestroy(): void {
    this.mylist = null;
  }

}
